"use client"

import { Toaster as Sonner, toast } from "sonner"

import { useTheme } from "../../hooks/useTheme"

/**
 * THE toast surface. Mounted once per app; call `toast()` anywhere.
 *
 * Theme comes from OUR `useTheme`, not `next-themes` — the only consumer of
 * that dependency, and it answered `"system"` by default, so a toast followed
 * the OS while every other surface followed the user's explicit choice. The
 * staff app had forked this entirely into a `Notice`/`NoticeBanner` pair with
 * its own fixed positioning and its own 4-second timer; that fork is deleted.
 */

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-ink-content group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-ink-supporting",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-ink-supporting",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
